<template>
    <c-popup-component
        @showAuthModal="showAuthModal"
        @carouselChange="carouselChange"
    />
</template>

<script>
import PopupComponent from './PopupComponent.vue';
import {PopupEmitter} from '@/utils/eventEmitter.js';
import {AsyncQueue} from '@/utils/asyncQueue.js';
import {POP_TYPE_RANK, POP_PAGE_NEED_SPECIAL_TASK_MAP, POP_PAGE_NEED_SPECIAL_TASK_ROUTE_MAP} from './PopupConfig.js';

export default {
    name: 'Popup',
    components: {
        'c-popup-component': PopupComponent
    },
    data() {
        return {
            asyncQueue: null,
            isProcessing: false,
            alreadyShowedPopup: [],
            currentPageIsShowPopup: false
        };
    },
    created() {
        // 获取通信实例
        this.emitter = PopupEmitter.getInstance();
        this.asyncQueue = AsyncQueue.getInstance();
        // 判断当前页面是否包含特殊弹窗，有的话则将currentPageNeedSpecialTask置为true锁死队列，不展示公共弹窗
        if (POP_PAGE_NEED_SPECIAL_TASK_MAP[window.location.pathname]) {
            this.asyncQueue.currentPageNeedSpecialTask = true;
        }
    },
    watch: {
        'asyncQueue.queue': {
            handler(newVal) {
                this.initPopup({
                    popups: newVal || [],
                    handlePopupList: POP_TYPE_RANK
                });
            },
            immediate: true
        },
        '$route'(to, from) {
            this.currentPageIsShowPopup = false;
            // 监听路由切换，展示公共弹窗，包含特殊任务的页面除外，程序初始化不执行
            if (from.path !== '/' && !POP_PAGE_NEED_SPECIAL_TASK_ROUTE_MAP[to.path]) {
                this.initPopup({
                    popups: this.asyncQueue.queue || [],
                    handlePopupList: POP_TYPE_RANK
                });
            }
        }
    },
    methods: {
        initPopup(options = {}) {
            const {currentPageNeedSpecialTask, currentPageSpecialTaskIsEnd} = this.asyncQueue || {};
            let {popups, handlePopupList} = options;
            if (!popups?.length) {
                return;
            }
            // 当前页面包含特殊弹窗，并且未添加任务到队列时，不继续执行
            if (currentPageNeedSpecialTask && !currentPageSpecialTaskIsEnd) {
                return;
            }
            if (this.currentPageIsShowPopup) {
                return;
            }
            this.currentPageIsShowPopup = true;
            // 弹窗过滤，只展示优先级队列中的弹窗，并且只展示未展示过的弹窗
            popups = popups.filter(popup => handlePopupList.includes(popup?.type))
                .filter(popup => !this.alreadyShowedPopup.includes(popup?.type));
            // 弹窗去重, 保留相对位置靠后的元素
            const map = new Map();
            for (const popup of popups) {
                map.set(popup?.type, popup); // 覆盖之前的值
            }
            popups = Array.from(map.values());

            // 弹窗排序
            popups.sort((a, b) => handlePopupList.indexOf(a?.type) - handlePopupList.indexOf(b?.type));

            // 弹窗处理
            const front = popups.shift();
            this.handlePopup(front);
        },
        handlePopup(popup) {
            if (this.isProcessing || !popup?.type) {
                return;
            }
            this.isProcessing = true;

            const params = popup?.params || {};
            try {
                this.emitter?.sendBroadcast({
                    type: params?.type,
                    data: params?.data
                });
                // 已展示过的弹窗添加到已展示的队列
                this.alreadyShowedPopup.push(popup?.type);
            }
            catch (e) {
                console.error(e);
            }
            this.isProcessing = false;
        },
        showAuthModal() {
            this.$emit('showAuthModal');
        },
        carouselChange(...args) {
            this.$emit('carouselChange', ...args);
        }
    }
};
</script>

<style></style>